import { lazy } from 'react';
var CNM00001 = lazy(function () { return import('view/Project/CNM/CNM00001'); });
var CNM_ROUTES = [
    { path: '/CNM00/CNM00001', component: CNM00001 },
];
export default CNM_ROUTES;
